var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGooglePlayStoreSvgrepoCom1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2200_214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.41822 0.0752861C1.59417 -0.0257722 1.81072 -0.0250453 1.98599 0.077192L10.8737 5.26168L8.12269 7.73756L1.13379 1.44755V0.566667C1.13379 0.363763 1.24227 0.176344 1.41822 0.0752861Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.13379 2.97241V14.0277L7.27561 8.50004L1.13379 2.97241Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.13379 15.5522V16.4332C1.13379 16.6361 1.24227 16.8236 1.41822 16.9247C1.59417 17.0256 1.81072 17.025 1.98599 16.9227L10.8738 11.7382L8.12269 9.26221L1.13379 15.5522Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9017 11.1387L15.5859 8.98951C15.76 8.88795 15.8671 8.70157 15.8671 8.50003C15.8671 8.29849 15.76 8.11212 15.5859 8.01056L11.9015 5.86133L8.96973 8.49997L11.9017 11.1387Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2200_214"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlayStoreSvgrepoCom1);
export default __webpack_public_path__ + "static/media/google-play-store-svgrepo-com 1.67c2bac3250636546d588585d3d2f2e6.svg";
export { ForwardRef as ReactComponent };